<template>
  <atomic-link class="install-app-menu-item" @click="installApp" v-if="allowInstall">
    <template v-if="!isDrawerCompact">
      <span class="install-app-menu-item__text">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.installApp') }}
      </span>
      <div class="install-app-menu-item__icons">
        <atomic-icon id="apple" />
        <atomic-icon id="android" />
      </div>
    </template>

    <template v-else>
      <atomic-icon id="install-app" />
    </template>
  </atomic-link>
</template>

<script setup lang="ts">
  import { UAParser } from 'ua-parser-js';

  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);
  const { getContent } = useProjectMethods();

  const userAgent = window.navigator.userAgent;
  const parsedUserAgent = userAgent ? UAParser(userAgent) : undefined;
  const appleNotCompatible = parsedUserAgent?.browser?.name === 'Safari' || parsedUserAgent?.os?.name === 'iOS';
  const allowInstall = ref<boolean>(!!window.pwa?.allowInstall || appleNotCompatible);

  const installApp = (): void => {
    window.pwa?.install();
    if (appleNotCompatible) {
      return;
    }

    if (window.pwa) {
      window.pwa?.install().then(res => {
        if (res.outcome === 'accepted') {
          allowInstall.value = false;
        }
      });
    }
  };

  const layoutStore = useLayoutStore();
  const { isDrawerCompact } = storeToRefs(layoutStore);
</script>

<style src="~/assets/styles/components/atomic/menu/install-app.scss" lang="scss" />
